/* eslint-disable react/prop-types */

import React from 'react';
import xss from 'xss';
import classNames from 'classnames';
import styles from '../styles.css';
import { USER_OPR_STATE } from '../constants';

// eslint-disable-next-line import/no-default-export -- FIXME: Convert to a named export https://github.com/wegotpop/popsss/wiki/Imports#default-exports
export default class Question extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      question: props.question.question,
      answer: props.question.answer,
    };
  }

  handleEditQuestion = () => {
    const { question, callbacks } = this.props;
    const questionJS = { ...question };
    callbacks.collapseQuestion(questionJS);
    callbacks.editQuestion(questionJS);
  };

  handleEditingQuestion = (e) => {
    this.setState(Object.assign({}, this.state, { question: e.target.value }));
  };

  handleEditingAnswer = (e) => {
    this.setState(Object.assign({}, this.state, { answer: e.target.value }));
  };

  handleSaveQuestionEdit = () => {
    const { question, callbacks } = this.props;
    const questionJS = { ...question };
    questionJS.question = this.state.question;
    questionJS.answer = this.state.answer;
    callbacks.saveQuestionEdit(questionJS);
  };

  handleCancelQuestionEdit = () => {
    const { question, callbacks } = this.props;
    const questionJS = { ...question };
    callbacks.cancelQuestionEdit(questionJS);
  };

  handleDeleteQuestion = () => {
    const { question, callbacks } = this.props;
    const questionJS = { ...question };
    callbacks.deleteQuestion(questionJS);
  };

  handlePublishQuestion = () => {
    const { question, callbacks } = this.props;
    const questionJS = { ...question };
    questionJS.publish = !questionJS.publish;
    callbacks.publishQuestion(questionJS);
  };

  handleMakeQuestionGlobal = () => {
    const { question, callbacks } = this.props;
    const questionJS = { ...question };
    questionJS.is_global = !questionJS.is_global;
    callbacks.makeQuestionGlobal(questionJS);
  };

  handleExpandQuestion = (e) => {
    e.preventDefault();
    const { question, callbacks } = this.props;
    const questionJS = { ...question };
    callbacks.expandQuestion(questionJS);
  };

  handleCollapseQuestion = (e) => {
    e.preventDefault();
    const { question, callbacks } = this.props;
    const questionJS = { ...question };
    callbacks.collapseQuestion(questionJS);
  };

  render() {
    const { question, editPermission, generalOprs, questionOprs } = this.props;

    if (!question) {
      return null;
    }

    const questionJS = { ...question };
    const isInEditing = questionOprs ? questionOprs.IN_EDITING : false;
    const isExpanded = questionOprs ? questionOprs.EXPANDED : false;

    const editButtonsNode = editPermission ? (
      <div className="btn-group btn-group-xs faq-btns">
        <button
          type="button"
          className={`btn btn-primary faq-edit-btn ${
            isInEditing ? 'disabled' : ''
          }`}
          onClick={isInEditing ? null : this.handleEditQuestion}
        >
          Edit
        </button>
        <button
          type="button"
          className="btn btn-danger faq-delete-btn"
          disabled={questionJS.publish}
          onClick={this.handleDeleteQuestion}
        >
          Delete
        </button>
        <button
          type="button"
          className="btn btn-success faq-publish-btn"
          onClick={this.handlePublishQuestion}
        >
          {questionJS.publish ? 'Unpublish' : 'Publish'}
        </button>
      </div>
    ) : null;

    const globalEditButtonNode = generalOprs[
      USER_OPR_STATE.EDIT_GLOBAL_PERM
    ] ? (
      <button
        className="btn btn-default btn-xs "
        onClick={this.handleMakeQuestionGlobal}
      >
        {questionJS.is_global ? 'Unmark as global' : 'Mark as global'}
      </button>
    ) : null;

    /* eslint-disable react/no-danger */
    // The use of dangerouslySetInnerHTML is accompanied with mitigating
    // measure against Cross-site scripting (XSS) with js-xss.
    return (
      <div
        className={classNames('panel', 'panel-default', {
          [styles.unpublished]: !questionJS.publish,
          [styles.faqGlobal]: questionJS.is_global && editPermission,
        })}
        data-faq-id={questionJS.faq_id}
      >
        <div className="panel-heading">
          <h4 className="panel-title">
            <div className="pull-right">
              {editButtonsNode}
              {globalEditButtonNode}
            </div>
            <a
              style={isInEditing ? { display: 'none' } : {}}
              className="accordion-toggle"
              data-parent={`#g_${questionJS.faq_id}`}
              href={`#q_${questionJS.faq_id}`}
              onClick={
                isExpanded
                  ? this.handleCollapseQuestion
                  : this.handleExpandQuestion
              }
            >
              {questionJS.question}
            </a>
            <input
              style={
                !isInEditing
                  ? { display: 'none', width: '50%' }
                  : { width: '50%' }
              }
              value={this.state.question}
              onChange={this.handleEditingQuestion}
            />
          </h4>
        </div>
        <div id={`q_${questionJS.faq_id}`} className="panel-collapse">
          <div
            className="panel-body"
            style={isInEditing || !isExpanded ? { display: 'none' } : {}}
            dangerouslySetInnerHTML={{ __html: xss(questionJS.answer) }}
          />
          <div
            className="panel-body"
            style={!isInEditing ? { display: 'none' } : {}}
          >
            <textarea
              className="form-control"
              value={this.state.answer}
              onChange={this.handleEditingAnswer}
            />
            <button
              className="btn btn-sm btn-success faq-question-button-save"
              type="button"
              onClick={this.handleSaveQuestionEdit}
            >
              Save changes
            </button>
            <button
              className="btn btn-sm btn-default faq-question-button-cancel"
              type="button"
              onClick={this.handleCancelQuestionEdit}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  }
}
